export default "__VITE_ASSET__9b95badf__"